import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'

export default class BugeteList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            strSearchString:'',
            elementeAfisate:[]
            
        } 
    }



    componentDidMount(){
       this.setState({ elementeAfisate:this.props.elemente || []})
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        if(tx !== null){

            return tx.substring(0,1).toUpperCase()
        }
    }

    filterFunc = (ev) => {

        this.setState({strSearchString:ev.target.value})
        let e = [...this.props.elemente]

        e = e.filter(x=>{
            
            if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            return false

        })

        this.setState({elementeAfisate: e})
    }

    render(){
        return (
            <div className='pm-users-list-container'>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{cursor:'pointer', position:'relative'}} className='pm-list-container'>
                <li className='pm-list-item-user' >
                                   
                                   <Grid container className='pm-list-container-avatar-head' >
                                   
                                       <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar-head'>
                                       
                                      <span className='pm-list-item-span-head'>{this.props.dict.bugete.nume}</span>
                         
                                       </Grid>
   
                                       <Grid item xs={2} sm={2} md={2} lg={2} xl={2}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.proiecte}</span>
                                       </Grid>
                                       <Grid item xs={2} sm={2} md={2} lg={2} xl={2}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.contabilitate}</span>
                                       </Grid>

                                       <Grid item xs={2} sm={2} md={2} lg={2} xl={2}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.intern}</span>
                                       </Grid>
                       
                                       
                                      
                                   </Grid>
                                      
                                   </li>
                  
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li className='pm-list-item-user' key={idx}  >
                                   
                                <Grid container   className='pm-list-container-avatar'>
                                
                                    <Grid onClick={()=>{this.setState({clickedEl:e, sterge:'block'})}}  style={{position:'relative'}} item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar'>
                                    <div className='pm-list-borderleft'></div>
                                    <span   className='pm-list-item-span'>{e[this.props.onlyColumns.nume]}</span>
                      
                                    </Grid>

                                    <Grid   item xs={2} sm={2} md={2} lg={2} xl={2}  className='pm-list-item-avatar'>
                                    <Switch
                                        className={e[this.props.onlyColumns.proiecte] !== 1 ? '' : "pm-switch"}
                                            checked={e[this.props.onlyColumns.proiecte] !== 1 ? false : true}
                                            onChange={()=>{this.props.handleProiecte(e)}}
                                            value='companie'
                                        />
                                    </Grid>

                                    <Grid  item xs={2} sm={2} md={2} lg={2} xl={2}  className='pm-list-item-avatar'>
                                    <Switch
                                        className={e[this.props.onlyColumns.contabilitate] !== 1 ? '' : "pm-switch"}
                                            checked={e[this.props.onlyColumns.contabilitate] !== 1 ? false : true}
                                            onChange={()=>{this.props.handleContabilitate(e)}}
                                            value='companie'
                                        />
                                    </Grid>
                                    <Grid style={{borderRight:'none'}} item xs={2} sm={2} md={2} lg={2} xl={2}  className='pm-list-item-avatar'>
                                    <Switch
                                        className={e[this.props.onlyColumns.intern] !== 1 ? '' : "pm-switch"}
                                            checked={e[this.props.onlyColumns.intern]  !== 1 ? false : true}
                                            onChange={()=>{this.props.handleIntern(e)}}
                                            value='companie'
                                        />
                                    </Grid>
                    
                                    
                                   
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


BugeteList.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    onElClick:PropTypes.func,
    handleProiecte:PropTypes.func,
    handleContabilitate:PropTypes.func,
    handleIntern:PropTypes.func

}